<dx-popup [width]="1250" [height]="520" [showTitle]="true" [dragEnabled]="true" [closeOnOutsideClick]="false"
  [(visible)]="mapsPopupVisible">
  <div *dxTemplate="let data of 'content'">
    <div id="map"></div>
    <div class="topmargin">
      <div *ngIf="!isReadOnly" class="leftfloat">
        <dx-button class="ap-green-btn mr-1 mt-1 ml-2 px-5" text="Save" (onClick)="OnSaveClicked()"></dx-button>
      </div>
      <div class="leftfloat">
        <dx-button class="ap-discard-button mr-1 mt-1 ml-2 px-5" text="Close" (onClick)="OnCloseClicked()">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>